
    import {defineComponent, reactive, ComputedRef, computed, watch} from 'vue'
    import {useRoute} from "vue-router";
    import {useStore} from "@/store";
    import  reportMsgUt from "@/util/reportMsg";


    interface State {
        channelType: string; // 家选 承诺100天
        antiFakeUrl: string;
        reportMsg: object;
        reportTipVersion: any;
    }
    export default defineComponent({
        name: "reminderText",
        setup() {
            let state: State = reactive({
                channelType: '',
                antiFakeUrl: '',
                reportMsg: {},
                reportTipVersion: null,
            })
            
            state.reportMsg = reportMsgUt;
            const {query} = useRoute();
            state.channelType = `${query.channelType}` || '';
            let store = useStore()
            let dataInfo: ComputedRef<{}> = computed<{}>(() => store.state.dataInfo)
            watch(dataInfo, (data: any) => {
                const {antiFakeUrl, reportTipVersion} = data
                state.antiFakeUrl = antiFakeUrl;
                state.reportTipVersion = reportTipVersion || null;
            })
            return {
                state
            }
        },
    })
